(function () {
  'use strict';
  const BundleState = {
    packSize: 5,
    discountTiers: {
      2: 0.05, 3: 0.11, 4: 0.15, 5: 0.20,
      6: 0.22, 7: 0.25, 8: 0.27, 9: 0.30, 10: 0.32
    },
    bundleItems: [],
    selectedCollection: null,
    selectedOptions: {},
    selectedProduct: null,
    selectedVariant: null,
    previousSelection: null,
    collections: [],
    siblingCollections: [],
    products: [],          
    allProducts: [],       
    currentCollection: null,
    parentCollection: null,
    moneyFormat: '${{amount}}',
    currency: 'USD',
    isFirstSelection: true,
    bundleRules: null, 
    bundleProductsGids: [], 
    isLoadingBundle: false
  };
  let drawer = null;
  let elements = {};
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return BundleState.moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }
  function getOrdinal(n) {
    const ordinals = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth'];
    return ordinals[n - 1] || '#' + n;
  }
  function init() {
    console.log('🚀 BundleDrawer initializing...');
    drawer = document.getElementById('bundle-drawer');
    if (!drawer) {
      console.warn('⚠️ Bundle drawer element not found');
      return;
    }
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    console.log('📋 Bundle Discount ID from DOM:', drawer.getAttribute('data-discount-id'));
    if (!window.BundleApi) {
      console.error('❌ BundleApi not found! Make sure bundle-api.js is loaded');
    }
    if (!window.ApiClient) {
      console.error('❌ ApiClient not found! Make sure api-client.js is loaded');
    }
    loadProductData();
    loadBundleRules();
    cacheElements();
    bindEvents();
    initializeUI();
  }
  function reloadData() {
    console.log('=== reloadData() called ===');
    const allDataScripts = document.querySelectorAll('#bundle-products-data');
    if (allDataScripts.length > 1) {
      console.log('Found multiple bundle-products-data scripts, keeping only the latest one');
      for (let i = 0; i < allDataScripts.length - 1; i++) {
        allDataScripts[i].remove();
      }
    }
    loadProductData();
    cacheElements();
    BundleState.selectedCollection = null;
    BundleState.selectedOptions = {};
    BundleState.selectedProduct = null;
    BundleState.selectedVariant = null;
    if (elements.collectionSelect) elements.collectionSelect.value = '';
    if (elements.dynamicOptions) elements.dynamicOptions.innerHTML = '';
    clearSwatches();
    hidePreview();
    document.querySelectorAll('[data-bundle-trigger]').forEach(function(btn) {
      var newBtn = btn.cloneNode(true);
      if (btn.parentNode) {
        btn.parentNode.replaceChild(newBtn, btn);
      }
      newBtn.addEventListener('click', openDrawer);
    });
    console.log('reloadData: Rebound trigger buttons, BundleState:', {
      productsCount: BundleState.products.length,
      currentCollection: BundleState.currentCollection ? BundleState.currentCollection.title : null,
      siblingCollectionsCount: BundleState.siblingCollections ? BundleState.siblingCollections.length : 0
    });
    initializeUI();
  }
  function loadProductData() {
    const dataScript = document.getElementById('bundle-products-data');
    if (dataScript) {
      try {
        const data = JSON.parse(dataScript.textContent);
        const initialProducts = data.collectionProducts || [];
        console.log('Raw initial products data (before normalize):', {
          count: initialProducts.length,
          firstProductRaw: initialProducts[0] ? {
            id: initialProducts[0].id,
            title: initialProducts[0].title,
            hasColorSwatch: !!initialProducts[0].colorSwatch,
            colorSwatch: initialProducts[0].colorSwatch,
            allKeys: Object.keys(initialProducts[0])
          } : null
        });
        BundleState.allProducts = initialProducts.map(product => normalizeProductData(product));
        BundleState.products = [...BundleState.allProducts];
        BundleState.currentCollection = data.currentCollection || null;
        BundleState.parentCollection = data.parentCollection || null;
        BundleState.siblingCollections = data.siblingSiblingCollections || data.siblingCollections || [];
        BundleState.moneyFormat = data.moneyFormat || BundleState.moneyFormat;
        BundleState.currency = data.currency || BundleState.currency;
        const productsWithSwatch = BundleState.products.filter(p => p.colorSwatch);
        const productsWithoutSwatch = BundleState.products.filter(p => !p.colorSwatch);
        console.log('Bundle Data Loaded (after normalize):', {
          currentCollection: BundleState.currentCollection ? BundleState.currentCollection.title : null,
          parentCollection: BundleState.parentCollection ? BundleState.parentCollection.title : null,
          siblingCollections: BundleState.siblingCollections ? BundleState.siblingCollections.length : null,
          productsCount: BundleState.products.length,
          productsWithSwatch: productsWithSwatch.length,
          productsWithoutSwatch: productsWithoutSwatch.length,
          sampleProduct: BundleState.products[0] ? {
            id: BundleState.products[0].id,
            title: BundleState.products[0].title,
            hasColorSwatch: !!BundleState.products[0].colorSwatch,
            colorSwatch: BundleState.products[0].colorSwatch
          } : null
        });
      } catch (e) {
        console.error('Error parsing bundle products data:', e);
      }
    }
  }
  function normalizeProductData(product) {
    const variants = product.variants || [];
    let options = product.options || [];
    if (options.length > 0 && typeof options[0] === 'object' && options[0].name) {
      options = options.map(opt => opt.name);
    }
    const normalized = {
      id: product.id,
      title: product.title,
      handle: product.handle,
      options: options,
      variants: variants.map(v => {
        const variantOptions = [];
        if (v.option1) variantOptions.push(v.option1);
        if (v.option2) variantOptions.push(v.option2);
        if (v.option3) variantOptions.push(v.option3);
        const finalOptions = (v.options && v.options.length > 0) ? v.options : variantOptions;
        if (finalOptions.length === 0 && (v.option1 || v.option2 || v.option3)) {
        }
        let price = typeof v.price === 'number' ? v.price : parseFloat(v.price) || 0;
        const priceStr = String(v.price);
        if (priceStr.includes('.')) {
          price = Math.round(parseFloat(priceStr) * 100);
          console.log('Converted price from currency string to cents:', v.price, '->', price);
        }
        let comparePrice = v.compareAtPrice || v.compare_at_price || 0;
        let comparePriceInt = typeof comparePrice === 'number' ? comparePrice : parseFloat(comparePrice) || 0;
        const comparePriceStr = String(comparePrice);
        if (comparePriceStr.includes('.')) {
          comparePriceInt = Math.round(parseFloat(comparePriceStr) * 100);
        }
        return {
          id: v.id,
          title: v.title,
          price: price,
          compare_at_price: comparePriceInt,
          available: v.available,
          featured_image: v.image || v.featured_image || product.featuredImage || product.featured_image,
          options: finalOptions
        };
      }),
      featured_image: product.featuredImage || product.featured_image,
      featuredImage: product.featuredImage || product.featured_image,
      available: product.available,
      product_type: product.type || product.product_type,
      colorSwatch: product.colorSwatch || product.color_swatch || null
    };
    // colorSwatch 可选，无需警告
    return normalized;
  }
  function cacheElements() {
    elements = {
      backdrop: drawer.querySelector('.bundle-drawer__backdrop'),
      closeBtn: drawer.querySelector('.bundle-drawer__close'),
      packSizeOptions: drawer.querySelectorAll('[data-pack-size]'),
      packOptionsContainer: drawer.querySelector('[data-pack-options]'),
      packMinus: drawer.querySelector('[data-pack-minus]'),
      packPlus: drawer.querySelector('[data-pack-plus]'),
      pairNumber: drawer.querySelector('[data-pair-number]'),
      collectionSelect: drawer.querySelector('[data-bundle-collection]'),
      dynamicOptions: drawer.querySelector('[data-bundle-dynamic-options]'),
      swatchesGrid: drawer.querySelector('[data-swatches-grid]'),
      swatchesEmpty: drawer.querySelector('[data-swatches-empty]'),
      preview: drawer.querySelector('[data-bundle-preview]'),
      previewImage: drawer.querySelector('[data-preview-image]'),
      previewName: drawer.querySelector('[data-preview-name]'),
      previewMeta: drawer.querySelector('[data-preview-meta]'),
      previewCompare: drawer.querySelector('[data-preview-compare]'),
      previewPrice: drawer.querySelector('[data-preview-price]'),
      addToBundle: drawer.querySelector('[data-add-to-bundle]'),
      bundleItems: drawer.querySelector('[data-bundle-items]'),
      bundleRemaining: drawer.querySelector('[data-bundle-remaining]'),
      remainingCount: drawer.querySelector('[data-remaining-count]'),
      bundleFooter: drawer.querySelector('[data-bundle-footer]'),
      bundleSaved: drawer.querySelector('[data-bundle-saved]'),
      bundleTotal: drawer.querySelector('[data-bundle-total]'),
      bundleCheckout: drawer.querySelector('[data-bundle-checkout]'),
      clearSelection: drawer.querySelector('[data-clear-selection]'),
      restoreContainer: drawer.querySelector('[data-bundle-restore]'),
      restoreBtn: drawer.querySelector('[data-restore-selection]'),
      collectionContainer: drawer.querySelector('[data-bundle-collection-container]'),
      loadingIndicator: drawer.querySelector('[data-bundle-loading]')
    };
  }
  function bindEvents() {
    const backdrop = drawer.querySelector('.bundle-drawer__backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', closeDrawer);
    }
    const content = drawer.querySelector('.bundle-drawer__content');
    if (content) {
      content.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
    if (elements.closeBtn) {
      elements.closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        closeDrawer();
      });
    }
    elements.packSizeOptions.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        selectPackSize(parseInt(btn.dataset.packSize));
      });
    });
    if (elements.packMinus) {
      elements.packMinus.addEventListener('click', (e) => {
        e.stopPropagation();
        if (BundleState.packSize > 2) {
          selectPackSize(BundleState.packSize - 1);
        }
      });
    }
    if (elements.packPlus) {
      elements.packPlus.addEventListener('click', (e) => {
        e.stopPropagation();
        if (BundleState.packSize < 10) {
          selectPackSize(BundleState.packSize + 1);
        }
      });
    }
    if (elements.collectionSelect) elements.collectionSelect.addEventListener('change', handleCollectionChange);
    if (elements.restoreBtn) elements.restoreBtn.addEventListener('click', restorePreviousSelection);
    if (elements.clearSelection) elements.clearSelection.addEventListener('click', resetToFirstSelection);
    if (elements.addToBundle) elements.addToBundle.addEventListener('click', addToBundle);
    if (elements.bundleCheckout) elements.bundleCheckout.addEventListener('click', checkout);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
    document.querySelectorAll('[data-bundle-trigger]').forEach(function(btn) {
      btn.addEventListener('click', openDrawer);
    });
  }
  function initializeUI() {
    const checkBundleLoaded = setInterval(function() {
      if (!BundleState.isLoadingBundle) {
        clearInterval(checkBundleLoaded);
        generatePackSizeOptions();
        selectPackSize(5);
        updateUI();
      }
    }, 100);
  }
  function generatePackSizeOptions() {
    if (!elements.packOptionsContainer) return;
    const tiers = BundleState.bundleRules && BundleState.bundleRules.tiers ? BundleState.bundleRules.tiers : [];
    if (tiers.length === 0) {
      console.warn('No bundle tiers found, using default configuration');
      return;
    }
    elements.packOptionsContainer.innerHTML = '';
    tiers.forEach(function(tier) {
      const option = document.createElement('button');
      option.type = 'button';
      option.className = 'bundle-pack-size__option';
      option.dataset.packSize = tier.minQuantity;
      const numberSpan = document.createElement('span');
      numberSpan.className = 'bundle-pack-size__number';
      numberSpan.textContent = tier.minQuantity;
      const discountSpan = document.createElement('span');
      discountSpan.className = 'bundle-pack-size__discount';
      const discountPercent = Math.round((tier.discountValue || 0) * 100);
      discountSpan.textContent = 'Save ' + discountPercent + '%';
      option.appendChild(numberSpan);
      option.appendChild(discountSpan);
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        selectPackSize(tier.minQuantity);
      });
      elements.packOptionsContainer.appendChild(option);
    });
    elements.packSizeOptions = drawer.querySelectorAll('[data-pack-size]');
  }
  async function loadBundleRules() {
    if (BundleState.bundleRules) {
      return BundleState.bundleRules;
    }
    if (BundleState.isLoadingBundle) {
      return new Promise((resolve) => {
        const checkLoaded = setInterval(() => {
          if (!BundleState.isLoadingBundle) {
            clearInterval(checkLoaded);
            resolve(BundleState.bundleRules);
          }
        }, 50);
      });
    }
    BundleState.isLoadingBundle = true;
    const discountId = (drawer && drawer.getAttribute('data-discount-id')) || '1';
    console.log('🔍 Loading Bundle Rules - Discount ID:', discountId);
    try {
      if (window.BundleApi && discountId) {
        const discountData = await window.BundleApi.getDiscount(discountId);
        console.log('📦 Bundle API Response:', discountData);
        if (discountData && discountData.primaryBundle) {
          const primary = discountData.primaryBundle;
          BundleState.bundleRules = {
            id: primary.id,
            name: primary.name,
            description: primary.description,
            isEnabled: primary.isEnabled,
            isAllProduct: primary.isAllProduct,
            products: primary.products || [],
            tiers: (primary.tiers || []).map(function (t) {
              return {
                minQuantity: t.minQuantity,
                percentage: t.percentage,
                discountValue: t.percentage / 100
              };
            })
          };
          BundleState.discountTiers = {};
          if (BundleState.bundleRules.tiers) {
            BundleState.bundleRules.tiers.forEach(function (tier) {
              BundleState.discountTiers[tier.minQuantity] = tier.percentage / 100;
            });
          }
          BundleState.bundleProductsGids = BundleState.bundleRules.isAllProduct ? null : (BundleState.bundleRules.products || []);
          console.log('Bundle rules loaded from API:', {
            bundleName: BundleState.bundleRules.name,
            isAllProduct: BundleState.bundleRules.isAllProduct,
            tiers: BundleState.bundleRules.tiers.length,
            productCount: BundleState.bundleProductsGids ? BundleState.bundleProductsGids.length : 'all'
          });
        }
      }
      if (!BundleState.bundleRules) {
        console.warn('Failed to load bundle rules from API, using fallback configuration');
        var data = {
          bundles: [{
            id: 3,
            name: 'bundle',
            tiers: [
              { percentage: 5, minQuantity: 2 },
              { percentage: 8, minQuantity: 3 },
              { percentage: 10, minQuantity: 4 },
              { percentage: 15, minQuantity: 5 },
              { percentage: 18, minQuantity: 6 },
              { percentage: 23, minQuantity: 7 },
              { percentage: 25, minQuantity: 8 },
              { percentage: 28, minQuantity: 9 },
              { percentage: 30, minQuantity: 10 }
            ],
            products: [],
            isEnabled: true,
            description: '',
            isAllProduct: true
          }]
        };
        if (data.bundles && data.bundles.length > 0) {
          BundleState.bundleRules = data.bundles[0];
          BundleState.bundleRules.tiers = (BundleState.bundleRules.tiers || []).map(function (t) {
            return { minQuantity: t.minQuantity, percentage: t.percentage, discountValue: (t.percentage || 0) / 100 };
          });
          BundleState.discountTiers = {};
          BundleState.bundleRules.tiers.forEach(function (tier) {
            BundleState.discountTiers[tier.minQuantity] = tier.percentage / 100;
          });
          BundleState.bundleProductsGids = BundleState.bundleRules.isAllProduct ? null : (BundleState.bundleRules.products || []);
        }
      }
      filterProductsByBundleRules();
    } catch (error) {
      console.error('Failed to load bundle rules:', error);
    } finally {
      BundleState.isLoadingBundle = false;
    }
    return BundleState.bundleRules;
  }
  function filterProductsByBundleRules() {
    if (!BundleState.allProducts || BundleState.allProducts.length === 0) {
      return;
    }
    if (!BundleState.bundleRules || BundleState.bundleRules.isAllProduct) {
      BundleState.products = [...BundleState.allProducts];
      console.log('No product filtering needed (isAllProduct=true)');
      return;
    }
    if (window.BundleApi && window.BundleApi.filterProductsByBundle) {
      const beforeCount = BundleState.allProducts.length;
      BundleState.products = window.BundleApi.filterProductsByBundle(
        BundleState.allProducts,
        BundleState.bundleRules
      );
      console.log('Products filtered by bundle rules:', {
        before: beforeCount,
        after: BundleState.products.length,
        removed: beforeCount - BundleState.products.length
      });
    } else {
      const bundleProductGids = new Set(BundleState.bundleProductsGids || []);
      BundleState.products = BundleState.allProducts.filter(function(product) {
        const productGid = 'gid://shopify/Product/' + product.id;
        return bundleProductGids.has(productGid);
      });
      console.log('Products filtered manually:', {
        total: BundleState.allProducts.length,
        filtered: BundleState.products.length
      });
    }
  }
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    loadBundleRules();
    BundleState.isFirstSelection = BundleState.bundleItems.length === 0;
    if (BundleState.isFirstSelection) {
      showSiblingCollections();
      if (elements.clearSelection) elements.clearSelection.classList.add('hidden');
      const container = elements.collectionContainer || drawer.querySelector('[data-bundle-collection-container]');
      if (container) {
        container.classList.add('hidden');
      }
    } else {
      showParentCollections();
      if (elements.clearSelection) elements.clearSelection.classList.remove('hidden');
    }
    setTimeout(() => {
      document.addEventListener('click', handleOutsideClick);
    }, 100);
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('click', handleOutsideClick);
  }
  function handleOutsideClick(event) {
    const content = drawer.querySelector('.bundle-drawer__content');
    if (content && !content.contains(event.target)) {
      closeDrawer();
    }
  }
  function resetToFirstSelection() {
    BundleState.selectedCollection = null;
    BundleState.selectedOptions = {};
    BundleState.selectedProduct = null;
    BundleState.selectedVariant = null;
    BundleState.products = [];
    if (elements.collectionSelect) elements.collectionSelect.value = '';
    if (elements.dynamicOptions) elements.dynamicOptions.innerHTML = '';
    clearSwatches();
    hidePreview();
    if (elements.clearSelection) elements.clearSelection.classList.add('hidden');
  }
  function selectPackSize(size) {
    BundleState.packSize = size;
    const availableSizes = Object.keys(BundleState.discountTiers).map(k => parseInt(k));
    if (availableSizes.length > 0 && !availableSizes.includes(size)) {
      size = availableSizes.reduce((prev, curr) => 
        Math.abs(curr - size) < Math.abs(prev - size) ? curr : prev
      );
      BundleState.packSize = size;
    }
    elements.packSizeOptions.forEach(function(btn) {
      btn.classList.toggle('is-active', parseInt(btn.dataset.packSize) === size);
    });
    centerPackSizeOption(size);
    const discount = BundleState.discountTiers[size] || 0;
    while (BundleState.bundleItems.length > size) {
      BundleState.bundleItems.pop();
    }
    updateUI();
  }
  function centerPackSizeOption(size) {
    if (!elements.packOptionsContainer) return;
    requestAnimationFrame(() => {
      const activeOption = Array.from(elements.packOptionsContainer.children).find(
        opt => parseInt(opt.dataset.packSize) === size
      );
      if (activeOption) {
        const container = elements.packOptionsContainer;
        const containerWidth = container.offsetWidth;
        const optionLeft = activeOption.offsetLeft;
        const optionWidth = activeOption.offsetWidth;
        const targetScrollLeft = optionLeft + (optionWidth / 2) - (containerWidth / 2);
        container.scrollTo({
          left: Math.max(0, targetScrollLeft),
          behavior: 'smooth'
        });
      }
    });
  }
  function showSiblingCollections() {
    if (!elements.collectionSelect || !BundleState.siblingCollections || BundleState.siblingCollections.length === 0) {
      console.warn('showSiblingCollections: Missing collectionSelect or siblingCollections', {
        hasCollectionSelect: !!elements.collectionSelect,
        siblingCollections: BundleState.siblingCollections,
        siblingCollectionsLength: BundleState.siblingCollections ? BundleState.siblingCollections.length : null
      });
      return;
    }
    let html = '';
    let hasSelected = false;
    BundleState.siblingCollections.forEach(function(collection) {
      const isSelected = BundleState.isFirstSelection && BundleState.currentCollection && collection.handle === BundleState.currentCollection.handle;
      if (isSelected) {
        html += '<option value="' + collection.handle + '" selected>' + collection.title + '</option>';
        hasSelected = true;
      } else {
        html += '<option value="' + collection.handle + '">' + collection.title + '</option>';
      }
    });
    if (!hasSelected) {
      html = '<option value="" disabled selected>Choose a Style</option>' + html;
    }
    elements.collectionSelect.innerHTML = html;
    console.log('showSiblingCollections:', {
      siblingCollectionsCount: BundleState.siblingCollections.length,
      htmlLength: html.length,
      hasSelected: hasSelected,
      currentCollection: BundleState.currentCollection ? BundleState.currentCollection.handle : null
    });
    if (BundleState.isFirstSelection && BundleState.currentCollection && BundleState.products.length > 0) {
      generateDynamicOptions();
    } else {
      if (elements.dynamicOptions) {
        elements.dynamicOptions.innerHTML = '';
      }
      clearSwatches();
      hidePreview();
    }
    if (elements.collectionContainer) {
      elements.collectionContainer.classList.add('hidden');
    }
    const optionsRow = drawer.querySelector('[data-bundle-options-row]');
    if (optionsRow) {
      optionsRow.classList.remove('hidden');
    }
    if (elements.restoreContainer) {
      elements.restoreContainer.classList.add('hidden');
    }
  }
  function showParentCollections() {
    if (!BundleState.parentCollection) return;
    if (elements.collectionContainer) {
      const subCollectionCount = BundleState.siblingCollections ? BundleState.siblingCollections.length : 0;
      const imageHtml = BundleState.parentCollection.image 
        ? '<img src="' + BundleState.parentCollection.image + '" alt="' + BundleState.parentCollection.title + '" loading="lazy">' 
        : '';
      const html = '<div class="bundle-collection-card" data-collection-handle="' + BundleState.parentCollection.handle + '">' +
          '<div class="bundle-collection-card__image">' + imageHtml + '</div>' +
          '<div class="bundle-collection-card__name">' + BundleState.parentCollection.title + '</div>' +
          '<div class="bundle-collection-card__count">' + subCollectionCount + ' styles</div>' +
        '</div>';
      elements.collectionContainer.innerHTML = html;
      elements.collectionContainer.classList.remove('hidden');
      const card = elements.collectionContainer.querySelector('.bundle-collection-card');
      if (card) {
        card.addEventListener('click', function() {
          handleParentCollectionClick(BundleState.parentCollection.handle);
        });
      }
    }
    const optionsRow = drawer.querySelector('[data-bundle-options-row]');
    if (optionsRow) {
      optionsRow.classList.add('hidden');
    }
    if (elements.restoreContainer) {
      elements.restoreContainer.classList.remove('hidden');
    }
    if (elements.dynamicOptions) {
      elements.dynamicOptions.innerHTML = '';
    }
    clearSwatches();
    hidePreview();
  }
  async function handleParentCollectionClick(handle) {
    const container = elements.collectionContainer || drawer.querySelector('[data-bundle-collection-container]');
    const optionsRow = drawer.querySelector('[data-bundle-options-row]');
    if (container) {
      container.classList.add('hidden');
    }
    if (optionsRow) {
      optionsRow.classList.remove('hidden');
    }
    showSiblingCollections();
    BundleState.products = [];
    if (elements.dynamicOptions) {
      elements.dynamicOptions.innerHTML = '';
    }
    clearSwatches();
    hidePreview();
  }
  function restorePreviousSelection() {
    showSiblingCollections();
    if (elements.collectionSelect) {
      elements.collectionSelect.value = '';
    }
    BundleState.products = [];
    BundleState.selectedCollection = null;
    BundleState.selectedOptions = {};
    if (elements.dynamicOptions) {
      elements.dynamicOptions.innerHTML = '';
    }
    clearSwatches();
    hidePreview();
    if (elements.restoreContainer) {
      elements.restoreContainer.classList.add('hidden');
    }
  }
  async function handleCollectionChange() {
    const handle = elements.collectionSelect.value;
    if (!handle) {
      clearProductSelection();
      hideLoading();
      return;
    }
    BundleState.selectedCollection = handle;
    if (BundleState.parentCollection && handle === BundleState.parentCollection.handle) {
      showSiblingCollections();
      if (BundleState.currentCollection && BundleState.products.length > 0) {
        generateDynamicOptions();
      }
      hideLoading();
    } else {
      showLoading();
      BundleState.selectedOptions = {};
      clearSwatches();
      hidePreview();
      await loadCollectionProducts(handle);
      hideLoading();
    }
    if (elements.clearSelection) elements.clearSelection.classList.remove('hidden');
  }
  function showLoading() {
    if (elements.loadingIndicator) {
      elements.loadingIndicator.classList.remove('hidden');
    }
    if (drawer) drawer.classList.add('is-loading');
  }
  function hideLoading() {
    if (elements.loadingIndicator) {
      elements.loadingIndicator.classList.add('hidden');
    }
    if (drawer) drawer.classList.remove('is-loading');
  }
  async function loadCollectionProducts(handle) {
    try {
      const url = '/collections/' + handle + '?view=bundle-products';
      console.log('Loading collection products from:', url);
      const response = await fetch(url);
      const contentType = response.headers.get('content-type');
      console.log('Response content-type:', contentType);
      if (!response.ok) {
        const text = await response.text();
        console.error('Failed to load collection: ' + handle, {
          status: response.status,
          statusText: response.statusText,
          contentType: contentType,
          responsePreview: text.substring(0, 500)
        });
        BundleState.products = [];
        if (elements.dynamicOptions) {
          elements.dynamicOptions.innerHTML = '';
        }
        return;
      }
      const responseText = await response.text();
      if (!contentType || !contentType.includes('application/json')) {
        if (responseText.trim().toLowerCase().startsWith('<!doctype') || responseText.trim().toLowerCase().startsWith('<html')) {
          console.warn('JSON view template not available, using fallback method for collection: ' + handle);
          await loadCollectionProductsFallback(handle);
          return;
        }
        console.warn('Content-Type is not JSON, but attempting to parse as JSON:', contentType);
      }
      let products;
      try {
        products = JSON.parse(responseText);
      } catch (parseError) {
        console.error('Failed to parse response as JSON for collection: ' + handle, {
          error: parseError,
          responsePreview: responseText.substring(0, 500),
          contentType: contentType,
          url: url
        });
        BundleState.products = [];
        if (elements.dynamicOptions) {
          elements.dynamicOptions.innerHTML = '';
        }
        return;
      }
      if (!Array.isArray(products) || products.length === 0) {
        console.warn('No products found in collection: ' + handle);
        BundleState.products = [];
        if (elements.dynamicOptions) {
          elements.dynamicOptions.innerHTML = '';
        }
        showNoProductsMessage();
        return;
      }
      console.log('Raw products data from API:', {
        count: products.length,
        firstProductRaw: products[0] ? {
          id: products[0].id,
          title: products[0].title,
          hasColorSwatch: !!products[0].colorSwatch,
          colorSwatch: products[0].colorSwatch,
          allKeys: Object.keys(products[0])
        } : null
      });
      BundleState.products = products.map(product => normalizeProductData(product));
      const productsWithSwatch = BundleState.products.filter(p => p.colorSwatch);
      const productsWithoutSwatch = BundleState.products.filter(p => !p.colorSwatch);
      console.log('Loaded ' + BundleState.products.length + ' products from ' + handle + ':', {
        withSwatch: productsWithSwatch.length,
        withoutSwatch: productsWithoutSwatch.length,
        sampleProduct: BundleState.products[0] ? {
          id: BundleState.products[0].id,
          title: BundleState.products[0].title,
          hasColorSwatch: !!BundleState.products[0].colorSwatch,
          colorSwatch: BundleState.products[0].colorSwatch
        } : null
      });
      // 部分产品无 colorSwatch 是正常的
      const optionsRow = drawer.querySelector('[data-bundle-options-row]');
      if (optionsRow) {
        optionsRow.classList.remove('hidden');
      }
      generateDynamicOptions();
    } catch (e) {
      console.error('Error loading collection products:', e);
      BundleState.products = [];
      if (elements.dynamicOptions) {
        elements.dynamicOptions.innerHTML = '';
      }
    }
  }
  async function loadCollectionProductsFallback(handle) {
    try {
      console.log('Using fallback method to load products for collection:', handle);
      const url = '/collections/' + handle;
      const response = await fetch(url);
      if (!response.ok) {
        console.error('Failed to load collection page via fallback: ' + handle, response.status);
        BundleState.products = [];
        if (elements.dynamicOptions) {
          elements.dynamicOptions.innerHTML = '';
        }
        return;
      }
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      if (!window.bundleDrawerParser) {
        window.bundleDrawerParser = parser;
      }
      let productDataScript = doc.getElementById('bundle-products-data');
      if (!productDataScript) {
        productDataScript = doc.getElementById('bundle-products-data-' + handle);
      }
      if (productDataScript) {
        try {
          const data = JSON.parse(productDataScript.textContent);
          const products = Array.isArray(data) ? data : (data.collectionProducts || []);
          if (products.length > 0) {
            BundleState.products = products.map(product => normalizeProductData(product));
            console.log('Loaded ' + BundleState.products.length + ' products via fallback (from page data) from ' + handle);
            BundleState.selectedOptions = {};
            clearSwatches();
            hidePreview();
            const optionsRow = drawer.querySelector('[data-bundle-options-row]');
            if (optionsRow) {
              optionsRow.classList.remove('hidden');
            }
            generateDynamicOptions();
            return;
          }
        } catch (e) {
          console.warn('Failed to parse product data from page:', e);
        }
      }
      console.warn('Page does not contain bundle-products-data script tag');
      console.warn('Page does not contain product data, using Products API and fetching metafields from product pages');
      const productsUrl = '/collections/' + handle + '/products.json';
      const productsResponse = await fetch(productsUrl);
      if (!productsResponse.ok) {
        console.error('Failed to load products via API: ' + handle, productsResponse.status);
        BundleState.products = [];
        if (elements.dynamicOptions) {
          elements.dynamicOptions.innerHTML = '';
        }
        return;
      }
      const productsData = await productsResponse.json();
      const products = productsData.products || [];
      if (products.length === 0) {
        console.warn('No products found in collection: ' + handle);
        BundleState.products = [];
        if (elements.dynamicOptions) {
          elements.dynamicOptions.innerHTML = '<div class="bundle-empty-message"><p>No products found in this collection.</p></div>';
        }
        return;
      }
      console.log('Loading metafields for ' + products.length + ' products from product pages...');
      const productParser = window.bundleDrawerParser || new DOMParser();
      const productsWithMetafields = await Promise.all(products.map(async (product) => {
        try {
          const productUrl = '/products/' + product.handle;
          const productResponse = await fetch(productUrl);
          if (productResponse.ok) {
            const productHtml = await productResponse.text();
            const productDoc = productParser.parseFromString(productHtml, 'text/html');
            const productDataScript = productDoc.getElementById('bundle-products-data');
            if (productDataScript) {
              try {
                const productData = JSON.parse(productDataScript.textContent);
                const collectionProducts = productData.collectionProducts || [];
                const currentProduct = collectionProducts.find(p => p.id === product.id);
                if (currentProduct && currentProduct.colorSwatch) {
                  product.colorSwatch = currentProduct.colorSwatch;
                  console.log('Found colorSwatch for product ' + product.handle);
                }
              } catch (e) {
                console.warn('Failed to parse product data for ' + product.handle + ':', e);
              }
            }
          }
        } catch (e) {
          console.warn('Failed to load metafields for product ' + product.handle + ':', e);
        }
        return product;
      }));
      BundleState.products = productsWithMetafields.map(product => normalizeProductData(product));
      const productsWithSwatch = BundleState.products.filter(p => p.colorSwatch);
      console.log('Loaded ' + BundleState.products.length + ' products via fallback (Products API + metafields) from ' + handle, {
        withColorSwatch: productsWithSwatch.length,
        withoutColorSwatch: BundleState.products.length - productsWithSwatch.length
      });
      // colorSwatch 为可选，产品可能使用原生 color 多属性
      BundleState.selectedOptions = {};
      clearSwatches();
      hidePreview();
      const optionsRow = drawer.querySelector('[data-bundle-options-row]');
      if (optionsRow) {
        optionsRow.classList.remove('hidden');
      }
      generateDynamicOptions();
    } catch (e) {
      console.error('Error loading collection products (fallback):', e);
      BundleState.products = [];
      if (elements.dynamicOptions) {
        elements.dynamicOptions.innerHTML = '';
      }
    }
  }
  function showNoProductsMessage() {
    const noProductsEl = drawer.querySelector('[data-bundle-no-products]');
    if (noProductsEl) {
      noProductsEl.classList.remove('hidden');
    }
  }
  function hideNoProductsMessage() {
    const noProductsEl = drawer.querySelector('[data-bundle-no-products]');
    if (noProductsEl) {
      noProductsEl.classList.add('hidden');
    }
  }
  function generateDynamicOptions() {
    if (!elements.dynamicOptions) {
      console.error('Dynamic options container not found!');
      return;
    }
    if (BundleState.products.length === 0) {
      elements.dynamicOptions.innerHTML = '';
      console.warn('No products to generate options from');
      showNoProductsMessage();
      return;
    }
    hideNoProductsMessage();
    const firstProduct = BundleState.products[0];
    if (!firstProduct) {
      elements.dynamicOptions.innerHTML = '';
      return;
    }
    let optionNames = firstProduct.options || [];
    optionNames = optionNames.map(name => {
      if (typeof name === 'string') {
        return name;
      } else if (name != null) {
        return String(name);
      }
      return null;
    }).filter(Boolean);
    if (optionNames.length === 0) {
      elements.dynamicOptions.innerHTML = '';
      console.warn('No options found in first product:', firstProduct);
      updateSwatches();
      return;
    }
    const colorSwatchOptionName = optionNames.find(name => {
      if (typeof name === 'string') {
        const lowerName = name.toLowerCase();
        return lowerName.includes('color') ||
          lowerName.includes('swatch') ||
          lowerName.includes('colour') ||
          lowerName.includes('颜色') ||
          lowerName.includes('色彩');
      }
      return false;
    });
    const sizeOptionName = optionNames.find(name => {
      if (typeof name === 'string') {
        const lowerName = name.toLowerCase();
        return lowerName.includes('size') ||
          lowerName.includes('尺码') ||
          lowerName.includes('尺寸');
      }
      return false;
    });
    if (!sizeOptionName) {
      elements.dynamicOptions.innerHTML = '';
      updateSwatches();
      return;
    }
    const sizeValues = new Set();
    const sizeOptionIndex = optionNames.indexOf(sizeOptionName);
    BundleState.products.forEach(product => {
      if (product.variants && product.variants.length > 0) {
        product.variants.forEach(variant => {
          if (variant.options && variant.options[sizeOptionIndex]) {
            sizeValues.add(variant.options[sizeOptionIndex]);
          }
        });
      }
    });
    const sizeValuesArray = Array.from(sizeValues);
    if (sizeValuesArray.length > 0) {
      let defaultSize = '';
      const previouslySelectedSize = BundleState.selectedOptions[sizeOptionName] || BundleState.selectedOptions[sizeOptionIndex];
      if (previouslySelectedSize && sizeValuesArray.includes(previouslySelectedSize)) {
        defaultSize = previouslySelectedSize;
      } else if (sizeValuesArray.length > 0) {
        defaultSize = sizeValuesArray[0];
      }
      console.log('generateDynamicOptions - Auto select size:', {
        previouslySelectedSize,
        defaultSize,
        sizeValuesArray,
        isFirstSelection: BundleState.isFirstSelection,
        bundleItemsLength: BundleState.bundleItems.length
      });
      let optionsHtml = '<option value="" disabled ' + (!defaultSize ? 'selected' : '') + '>Choose a Size</option>';
      sizeValuesArray.forEach(function(value) {
        optionsHtml += '<option value="' + value + '" ' + (value === defaultSize ? 'selected' : '') + '>' + value + '</option>';
      });
      elements.dynamicOptions.innerHTML = 
        '<div class="bundle-option">' +
          '<div class="bundle-option__select">' +
            '<select data-option-index="' + sizeOptionIndex + '" data-option-name="' + sizeOptionName + '">' +
              optionsHtml +
            '</select>' +
            '<span class="bundle-option__arrow">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>' +
            '</span>' +
          '</div>' +
        '</div>';
      const select = elements.dynamicOptions.querySelector('select');
      if (select) {
        select.addEventListener('change', handleOptionChange);
      }
      if (defaultSize) {
        BundleState.selectedOptions[sizeOptionIndex] = defaultSize;
        BundleState.selectedOptions[sizeOptionName] = defaultSize;
      }
    }
    updateSwatches();
  }
  function handleOptionChange() {
    BundleState.selectedOptions = {};
    const select = elements.dynamicOptions ? elements.dynamicOptions.querySelector('select') : null;
    if (select) {
      const optionIndex = parseInt(select.dataset.optionIndex);
      const optionName = select.dataset.optionName;
      const value = select.value;
      if (value && value.trim() !== '') {
        BundleState.selectedOptions[optionIndex] = value;
        BundleState.selectedOptions[optionName] = value;
      }
    }
    console.log('handleOptionChange - Selected size:', BundleState.selectedOptions);
    updateSwatches();
  }
  function clearProductSelection() {
    BundleState.selectedCollection = null;
    BundleState.selectedOptions = {};
    BundleState.products = [];
    if (elements.dynamicOptions) elements.dynamicOptions.innerHTML = '';
    clearSwatches();
    hidePreview();
  }
  function isProductInBundleRules(product) {
    if (!BundleState.bundleRules) {
      return true;
    }
    if (BundleState.bundleRules.isAllProduct) {
      return true;
    }
    if (BundleState.bundleProductsGids && BundleState.bundleProductsGids.length > 0) {
      const productGid = 'gid://shopify/Product/' + product.id;
      return BundleState.bundleProductsGids.includes(productGid);
    }
    return false;
  }
  function updateSwatches() {
    if (!elements.swatchesGrid) return;
    const firstProduct = BundleState.products[0];
    if (!firstProduct || !firstProduct.options) {
      console.warn('updateSwatches: No products or first product has no options');
      clearSwatches();
      return;
    }
    const optionNames = firstProduct.options || [];
    const colorSwatchOptionIndex = optionNames.findIndex(name => {
      if (typeof name === 'string') {
        const lowerName = name.toLowerCase();
        return lowerName.includes('color') ||
          lowerName.includes('swatch') ||
          lowerName.includes('colour') ||
          lowerName.includes('颜色') ||
          lowerName.includes('色彩');
      }
      return false;
    });
    const sizeOptionIndex = optionNames.findIndex(name => {
      if (typeof name === 'string') {
        const lowerName = name.toLowerCase();
        return lowerName.includes('size') ||
          lowerName.includes('尺码') ||
          lowerName.includes('尺寸');
      }
      return false;
    });
    const selectedSize = BundleState.selectedOptions[sizeOptionIndex];
    const previouslySelectedProductId = BundleState.selectedProduct ? BundleState.selectedProduct.id : null;
    console.log('updateSwatches:', {
      colorSwatchOptionIndex,
      sizeOptionIndex,
      selectedSize,
      totalProducts: BundleState.products.length,
      previouslySelectedProductId
    });
    const allProducts = BundleState.products.filter(product => {
      if (!product.colorSwatch) {
        return false;
      }
      if (!isProductInBundleRules(product)) {
        return false;
      }
      return true;
    });
    if (allProducts.length === 0) {
      elements.swatchesGrid.classList.add('hidden');
      if (elements.swatchesEmpty) elements.swatchesEmpty.classList.remove('hidden');
      return;
    }
    if (elements.swatchesEmpty) elements.swatchesEmpty.classList.add('hidden');
    elements.swatchesGrid.classList.remove('hidden');
    let html = '';
    allProducts.forEach(function(product) {
      const swatch = extractColorSwatch(product);
      let swatchContent = generateSwatchContent(swatch, product);
      if (!swatchContent || typeof swatchContent !== 'string' || swatchContent.includes('swatch-placeholder')) {
        if (product.featuredImage) {
          swatchContent = '<img src="' + product.featuredImage + '" alt="' + product.title + '" class="swatch-image" loading="lazy" width="44" height="44">';
        } else if (product.featured_image) {
          swatchContent = '<img src="' + product.featured_image + '" alt="' + product.title + '" class="swatch-image" loading="lazy" width="44" height="44">';
        } else {
          swatchContent = '<div class="swatch-placeholder">' + ((product.title || '').charAt(0).toUpperCase()) + '</div>';
        }
      }
      let swatchName = product.title;
      if (swatch) {
        if (typeof swatch === 'object') {
          if (Array.isArray(swatch) && swatch.length > 0) {
            swatchName = swatch[0].name || product.title;
          } else if (swatch.name) {
            swatchName = swatch.name;
          }
        } else if (typeof swatch === 'string') {
          swatchName = swatch;
        }
      }
      let swatchStatus = ''; 
      let isClickable = true;
      if (selectedSize && sizeOptionIndex >= 0) {
        const hasSize = product.variants.some(variant => 
          variant.options && variant.options[sizeOptionIndex] === selectedSize
        );
        if (!hasSize) {
          swatchStatus = 'size-not-produced';
          isClickable = false;
        } else {
          const sizeAvailable = product.variants.some(variant => 
            variant.options && 
            variant.options[sizeOptionIndex] === selectedSize && 
            variant.available
          );
          if (!sizeAvailable) {
            swatchStatus = 'size-out-of-stock';
            isClickable = false;
          }
        }
      }
      html += '<div class="color-swatch-item' + (swatchStatus ? ' ' + swatchStatus : '') + '" ' +
             'data-product-id="' + product.id + '" ' +
             'data-product-handle="' + product.handle + '" ' +
             'aria-label="' + swatchName + '" ' +
             'title="' + swatchName + '" ' +
             (!isClickable ? 'aria-disabled="true"' : '') + '>' +
          swatchContent +
        '</div>';
    });
    elements.swatchesGrid.innerHTML = html;
    const clickableSwatches = [];
    elements.swatchesGrid.querySelectorAll('.color-swatch-item').forEach(function(swatch) {
      if (swatch.getAttribute('aria-disabled') !== 'true') {
        swatch.addEventListener('click', function() {
          selectSwatch(swatch);
        });
        clickableSwatches.push(swatch);
      }
    });
    elements.swatchesGrid.classList.remove('hidden');
    if (elements.swatchesEmpty) elements.swatchesEmpty.classList.add('hidden');
    let swatchToSelect = null;
    if (previouslySelectedProductId) {
      const previousSwatch = clickableSwatches.find(swatch => 
        parseInt(swatch.dataset.productId) === previouslySelectedProductId
      );
      if (previousSwatch) {
        swatchToSelect = previousSwatch;
        console.log('Restoring previous swatch selection:', previouslySelectedProductId);
      } else {
        console.log('Previous product not available in new size, selecting first available');
        swatchToSelect = clickableSwatches.length > 0 ? clickableSwatches[0] : null;
      }
    } else if (BundleState.isFirstSelection && BundleState.bundleItems.length === 0) {
      swatchToSelect = clickableSwatches.length > 0 ? clickableSwatches[0] : null;
      console.log('First selection, auto-selecting first swatch');
    }
    if (swatchToSelect) {
      setTimeout(() => {
        selectSwatch(swatchToSelect);
      }, 100);
    }
  }
  function extractColorSwatch(product) {
    if (product.colorSwatch) {
      if (Array.isArray(product.colorSwatch) && product.colorSwatch.length > 0) {
        return product.colorSwatch[0];
      }
      return product.colorSwatch;
    }
    if (product.metafields && Array.isArray(product.metafields)) {
      const swatchField = product.metafields.find(m =>
        (m.namespace === 'custom' && m.key === 'color_swatch') ||
        m.key === 'color_swatch'
      );
      if (swatchField && swatchField.value) {
        if (Array.isArray(swatchField.value) && swatchField.value.length > 0) {
          return swatchField.value[0];
        }
        return swatchField.value;
      }
    }
    return null;
  }
  function generateSwatchContent(swatch, product) {
    let swatchData = null;
    if (Array.isArray(swatch) && swatch.length > 0) {
      swatchData = swatch[0];
    } else if (swatch && typeof swatch === 'object') {
      swatchData = swatch;
    }
    console.log('generateSwatchContent DEBUG:', {
      productTitle: product.title,
      originalSwatch: swatch,
      swatchData: swatchData,
      swatchDataImage: swatchData ? swatchData.image : null,
      swatchDataColor: swatchData ? swatchData.color : null,
      productFeaturedImage: product.featuredImage,
      productFeatured_image: product.featured_image
    });
    if (swatchData) {
      let imageUrl = null;
      if (swatchData.image) {
        if (typeof swatchData.image === 'string') {
          imageUrl = swatchData.image;
        } else if (swatchData.image.url) {
          imageUrl = swatchData.image.url;
        } else if (typeof swatchData.image === 'object' && swatchData.image.src) {
          imageUrl = swatchData.image.src;
        }
      }
      if (!imageUrl && swatchData.image) {
        console.warn('Could not extract image URL from swatchData.image:', swatchData.image, 'for product:', product.title);
      }
      if (imageUrl) {
        return '<img src="' + imageUrl + '" alt="' + (swatchData.name || product.title) + '" class="swatch-image" loading="lazy" width="44" height="44">';
      }
      if (swatchData.color) {
        let colorValue = '';
        if (typeof swatchData.color === 'string') {
          if (swatchData.color.startsWith('rgb')) {
            colorValue = swatchData.color;
          } else if (swatchData.color.startsWith('#')) {
            colorValue = swatchData.color;
          } else {
            colorValue = swatchData.color;
          }
        } else if (swatchData.color.rgb) {
          colorValue = 'rgb(' + swatchData.color.rgb + ')';
        } else if (swatchData.color.r !== undefined && swatchData.color.g !== undefined && swatchData.color.b !== undefined) {
          colorValue = 'rgb(' + swatchData.color.r + ', ' + swatchData.color.g + ', ' + swatchData.color.b + ')';
        } else {
          console.warn('Unknown color format for product:', product.title, 'Color data:', swatchData.color);
          colorValue = 'rgb(200, 200, 200)';
        }
        return '<div class="swatch-color" style="background-color: ' + colorValue + ';"></div>';
      }
      if (product.featured_image) {
        const imageUrl = product.featured_image.includes('http') ? product.featured_image : product.featured_image;
        return '<img src="' + imageUrl + '" alt="' + product.title + '" class="swatch-image" loading="lazy" width="44" height="44">';
      } else if (product.featuredImage) {
        return '<img src="' + product.featuredImage + '" alt="' + product.title + '" class="swatch-image" loading="lazy" width="44" height="44">';
      }
      const placeholderText = (swatchData.name || product.title || '').charAt(0).toUpperCase();
      return '<div class="swatch-placeholder">' + placeholderText + '</div>';
    }
    if (product.featured_image) {
      return '<img src="' + product.featured_image + '" alt="' + product.title + '" class="swatch-image" loading="lazy" width="44" height="44">';
    } else if (product.featuredImage) {
      return '<img src="' + product.featuredImage + '" alt="' + product.title + '" class="swatch-image" loading="lazy" width="44" height="44">';
    }
    const placeholderText = (product.title || '').charAt(0).toUpperCase();
    return '<div class="swatch-placeholder">' + placeholderText + '</div>';
  }
  function clearSwatches() {
    if (elements.swatchesGrid) {
      elements.swatchesGrid.innerHTML = '';
      elements.swatchesGrid.classList.add('hidden');
    }
    if (elements.swatchesEmpty) elements.swatchesEmpty.classList.add('hidden');
  }
  function selectSwatch(swatchElement) {
    if (elements.swatchesGrid) {
      elements.swatchesGrid.querySelectorAll('.color-swatch-item').forEach(s => {
        s.classList.remove('active');
        s.removeAttribute('aria-current');
      });
    }
    swatchElement.classList.add('active');
    swatchElement.setAttribute('aria-current', 'true');
    const productId = parseInt(swatchElement.dataset.productId);
    const product = BundleState.products.find(p => p.id === productId);
    console.log('=== selectSwatch DEBUG ===');
    console.log('Product ID:', productId);
    console.log('Found product:', product);
    console.log('Product variants:', product ? product.variants : null);
    console.log('Product variants prices:', product && product.variants ? product.variants.map(v => ({
      title: v.title,
      price: v.price,
      priceType: typeof v.price,
      options: v.options
    })) : []);
    if (product) {
      const firstProduct = BundleState.products[0];
      const optionNames = firstProduct && firstProduct.options ? firstProduct.options : [];
      const colorSwatchOptionIndex = optionNames.findIndex(name => {
        if (typeof name === 'string') {
          return name.toLowerCase().includes('color') || name.toLowerCase().includes('swatch');
        }
        return false;
      });
      let matchingVariant = null;
      let productColorValue = null;
      if (colorSwatchOptionIndex >= 0 && product.variants.length > 0) {
        const firstVariant = product.variants[0];
        if (firstVariant.options && firstVariant.options[colorSwatchOptionIndex]) {
          productColorValue = firstVariant.options[colorSwatchOptionIndex];
        }
      }
      product.variants.forEach(variant => {
        if (!variant.options || variant.options.length === 0) return;
        let matches = true;
        if (elements.dynamicOptions) {
          elements.dynamicOptions.querySelectorAll('select').forEach(select => {
            const optionIndex = parseInt(select.dataset.optionIndex);
            const selectedValue = select.value;
            if (optionIndex === colorSwatchOptionIndex) return;
            if (selectedValue && variant.options[optionIndex] !== selectedValue) {
              matches = false;
            }
          });
        }
        if (matches && colorSwatchOptionIndex >= 0 && productColorValue) {
          if (variant.options[colorSwatchOptionIndex] !== productColorValue) {
            matches = false;
          }
        }
        if (matches && !matchingVariant) {
          matchingVariant = variant;
        }
      });
      if (!matchingVariant && product.variants.length > 0) {
        const availableVariant = product.variants.find(v => v.available);
        matchingVariant = availableVariant || product.variants[0];
      }
      BundleState.selectedProduct = product;
      BundleState.selectedVariant = matchingVariant;
      if (matchingVariant) {
        showPreview(product, matchingVariant);
      }
    }
  }
  function showPreview(product, variant) {
    if (!elements.preview) return;
    elements.preview.classList.remove('hidden');
    console.log('=== showPreview DEBUG ===');
    console.log('Product ID:', product.id);
    console.log('Product title:', product.title);
    console.log('Product keys:', Object.keys(product));
    console.log('product.featuredImage:', product.featuredImage);
    console.log('product.featuredImage type:', typeof product.featuredImage);
    console.log('product.featured_image:', product.featured_image);
    console.log('product.featured_image type:', typeof product.featured_image);
    let imageData = product.featuredImage || 
                    product.featured_image || 
                    product.image ||
                    (product.variants && product.variants[0] && product.variants[0].featured_image) ||
                    (product.variants && product.variants[0] && product.variants[0].image) ||
                    null;
    let imageSrc = null;
    console.log('Selected imageData:', imageData);
    console.log('imageData type:', typeof imageData);
    if (imageData) {
      if (typeof imageData === 'string') {
        imageSrc = imageData;
        console.log('Using string URL directly:', imageSrc);
      } else if (typeof imageData === 'object' && imageData !== null) {
        console.log('imageData is object, keys:', Object.keys(imageData));
        imageSrc = imageData.src || imageData.url || null;
        console.log('Extracted image URL:', imageSrc);
      }
    }
    console.log('Final imageSrc:', imageSrc);
    if (elements.previewImage) {
      if (imageSrc) {
        elements.previewImage.src = imageSrc;
        elements.previewImage.alt = product.title;
        elements.previewImage.style.display = '';
        elements.previewImage.onerror = () => {
          console.error('Failed to load preview image:', imageSrc);
        };
      } else {
        console.warn('No image available for preview');
        console.warn('Product object:', product);
        elements.previewImage.style.display = 'none';
      }
    }
    if (elements.previewName) {
      elements.previewName.textContent = product.title;
    }
    if (elements.previewMeta) {
      const parts = [product.product_type, ...variant.options].filter(Boolean);
      elements.previewMeta.textContent = parts.join(' · ');
    }
    const price = variant.price;
    const comparePrice = variant.compare_at_price;
    console.log('showPreview - Price debug:', {
      productTitle: product.title,
      variantTitle: variant.title,
      rawPrice: price,
      priceType: typeof price,
      rawComparePrice: comparePrice,
      formattedPrice: formatMoney(price),
      formattedComparePrice: comparePrice ? formatMoney(comparePrice) : 'N/A'
    });
    if (elements.previewPrice) {
      elements.previewPrice.textContent = formatMoney(price);
    }
    if (elements.previewCompare) {
      if (comparePrice && comparePrice > price) {
        elements.previewCompare.textContent = formatMoney(comparePrice);
        elements.previewCompare.style.display = '';
      } else {
        elements.previewCompare.style.display = 'none';
      }
    }
    if (elements.addToBundle) elements.addToBundle.classList.remove('hidden');
  }
  function hidePreview() {
    if (elements.preview) elements.preview.classList.add('hidden');
    if (elements.addToBundle) elements.addToBundle.classList.add('hidden');
    BundleState.selectedProduct = null;
    BundleState.selectedVariant = null;
  }
  function addToBundle() {
    if (!BundleState.selectedProduct || !BundleState.selectedVariant) return;
    if (BundleState.bundleItems.length >= BundleState.packSize) return;
    BundleState.bundleItems.push({
      product: BundleState.selectedProduct,
      variant: BundleState.selectedVariant
    });
    BundleState.isFirstSelection = false;
    resetToFirstSelection();
    showParentCollections();
    updateUI();
  }
  function removeFromBundle(index) {
    BundleState.bundleItems.splice(index, 1);
    updateUI();
  }
  function updateUI() {
    updatePairNumber();
    updateBundleItemsList();
    updateRemainingCount();
    updateSummary();
    updateFooterVisibility();
  }
  function updatePairNumber() {
    if (!elements.pairNumber) return;
    const nextPairNumber = BundleState.bundleItems.length + 1;
    if (BundleState.bundleItems.length > 0) {
      elements.pairNumber.textContent = 'next';
    } else {
      elements.pairNumber.textContent = getOrdinal(nextPairNumber);
    }
  }
  function updateBundleItemsList() {
    if (!elements.bundleItems) return;
    if (BundleState.bundleItems.length === 0) {
      elements.bundleItems.innerHTML = '';
      return;
    }
    let html = '';
    BundleState.bundleItems.forEach((item, index) => {
      const product = item.product;
      const variant = item.variant;
      let imageData = variant.featured_image || 
                      variant.image || 
                      product.featured_image || 
                      product.featuredImage || 
                      null;
      let imageSrc = null;
      if (imageData) {
        if (typeof imageData === 'string') {
          imageSrc = imageData;
        } else if (typeof imageData === 'object' && imageData !== null) {
          imageSrc = imageData.src || imageData.url || null;
        }
      }
      const isNewItem = index === BundleState.bundleItems.length - 1 && !item.isOld;
      const imageHtml = imageSrc ? '<img src="' + imageSrc + '" alt="' + product.title + '">' : '';
      html += '<div class="bundle-item' + (isNewItem ? ' is-new' : '') + '">' +
          '<div class="bundle-item__image">' + imageHtml + '</div>' +
          '<div class="bundle-item__info">' +
            '<h4 class="bundle-item__name">' + product.title + '</h4>' +
            '<p class="bundle-item__meta">' + (product.product_type || '') + ' · ' + variant.options.join(' · ') + '</p>' +
          '</div>' +
          '<button type="button" class="bundle-item__remove" data-remove-index="' + index + '">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<polyline points="3 6 5 6 21 6"></polyline>' +
              '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
            '</svg>' +
          '</button>' +
        '</div>';
    });
    elements.bundleItems.innerHTML = html;
    elements.bundleItems.querySelectorAll('[data-remove-index]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        removeFromBundle(parseInt(btn.dataset.removeIndex));
      });
    });
    BundleState.bundleItems.forEach(function(item) {
      item.isOld = true;
    });
  }
  function updateRemainingCount() {
    const remaining = BundleState.packSize - BundleState.bundleItems.length;
    if (elements.remainingCount) {
      elements.remainingCount.textContent = remaining;
    }
    if (elements.bundleRemaining) {
      elements.bundleRemaining.classList.toggle('hidden', remaining === 0 || remaining === BundleState.packSize || BundleState.bundleItems.length === 0);
    }
  }
  function updateSummary() {
    const discount = BundleState.discountTiers[BundleState.packSize] || 0;
    let subtotal = 0;
    BundleState.bundleItems.forEach(item => {
      const itemPrice = typeof item.variant.price === 'number' ? item.variant.price : parseInt(item.variant.price) || 0;
      subtotal += itemPrice;
    });
    const discountAmount = Math.round(subtotal * discount);
    const total = subtotal - discountAmount;
    console.log('updateSummary - Price debug:', {
      packSize: BundleState.packSize,
      discount: discount,
      itemPrices: BundleState.bundleItems.map(item => ({
        title: item.product.title,
        price: item.variant.price,
        priceType: typeof item.variant.price
      })),
      subtotal: subtotal,
      discountAmount: discountAmount,
      total: total,
      formattedSaved: formatMoney(discountAmount),
      formattedTotal: formatMoney(total)
    });
    if (elements.bundleSaved) {
      elements.bundleSaved.textContent = formatMoney(discountAmount);
    }
    if (elements.bundleTotal) {
      elements.bundleTotal.textContent = formatMoney(total);
    }
  }
  function updateFooterVisibility() {
    const isComplete = BundleState.bundleItems.length === BundleState.packSize;
    if (elements.bundleFooter) {
      elements.bundleFooter.classList.toggle('hidden', !isComplete);
    }
    const selectionSection = drawer.querySelector('[data-bundle-selection]');
    if (selectionSection) {
      selectionSection.classList.toggle('hidden', isComplete);
    }
  }
  async function checkout() {
    if (BundleState.bundleItems.length !== BundleState.packSize) return;
    const items = BundleState.bundleItems.map(item => ({
      id: item.variant.id,
      quantity: 1
    }));
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (response.ok) {
        console.log('Successfully added bundle to cart');
        closeDrawer();
        BundleState.bundleItems = [];
        updateUI();
        hidePreview();
        const sectionsToFetch = ['cart-drawer'];
        const sectionRequests = sectionsToFetch.map(section => {
          return fetch('/?section_id=' + section)
            .then(res => res.text())
            .then(html => ({ section, html }));
        });
        Promise.all(sectionRequests).then(results => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            const cartDrawerData = results.find(r => r.section === 'cart-drawer');
            if (cartDrawerData) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(cartDrawerData.html, 'text/html');
              const newCartDrawer = doc.querySelector('cart-drawer');
              if (newCartDrawer) {
                cartDrawer.innerHTML = newCartDrawer.innerHTML;
                setTimeout(() => {
                  cartDrawer.open();
                }, 100);
              }
            }
          }
          updateCartCounters();
        }).catch(error => {
          console.error('Error refreshing cart drawer:', error);
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        });
      } else {
        alert('Failed to add items to cart. Please try again.');
      }
    } catch (error) {
      console.error('Error during checkout:', error);
      alert('An error occurred. Please try again.');
    }
  }
  async function updateCartCounters() {
    const headerCartCounters = document.querySelectorAll('.cart-count-badge');
    const drawerCartCounters = document.querySelectorAll('.cart-drawer__title-counter');
    const cartCounters = [...headerCartCounters, ...drawerCartCounters].filter(counter => counter !== null);
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.ok) {
        const cart = await response.json();
        cartCounters.forEach(counter => {
          counter.textContent = cart.item_count;
        });
      }
    } catch (error) {
      console.error('Error updating cart counters:', error);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.BundleDrawer = {
    open: openDrawer,
    close: closeDrawer,
    getState: () => BundleState,
    reloadData: reloadData
  };
})();
